import { type BuyboxReducerAction, type BuyboxReducerState } from '../types/buyboxReducerTypes';
import { BuyboxReducerActionType } from '../types/enums/reducer/buyboxReducerAction';

export function buyboxReducer(
    state: BuyboxReducerState,
    action: BuyboxReducerAction,
): BuyboxReducerState {
    switch (action.type) {
        case BuyboxReducerActionType.PurchaseType: {
            return {
                ...state,
                purchaseType: action.value.purchaseType,
            };
        }

        case BuyboxReducerActionType.CookieWarning: {
            return {
                ...state,
                hasCookieWarning: true,
            };
        }

        case BuyboxReducerActionType.MixedShoppingCartError: {
            return {
                ...state,
                hasMixedShoppingCartError: true,
            };
        }

        case BuyboxReducerActionType.AddingMultipleItemsNotAllowedError: {
            return {
                ...state,
                hasAddingMultipleItemsError: true,
            };
        }

        case BuyboxReducerActionType.AddToCartError: {
            return {
                ...state,
                hasAddToCartError: true,
            };
        }

        case BuyboxReducerActionType.ResetErrors: {
            return {
                ...state,
                hasCookieWarning: false,
                hasMixedShoppingCartError: false,
                hasAddingMultipleItemsError: false,
                hasAddToCartError: false,
            };
        }

        default:
            return state;
    }
}
